/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/NotesCell/Content/Note"
  
}) {
let noteItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'note_item',
path: 'isLast',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
  return (<React.Fragment
>
<div
  data-testid="Note.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-aI8I': noteItemIsLastValueData ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 data="note.note"
 html={noteNoteValueData}
/>
</div>
{children}
</React.Fragment>)
}